export default "__VITE_ASSET__Ciyz5RgU__"